module.exports = __webpack_public_path__ + "img/malayali.284dad1c.svg";